import React, { Component } from "react";
import { Microcentrifuge } from "@learningblocks/storybook-components";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { css } from "glamor";
import Toast from "../../../../Dialogs/toast/Toast";

// Styles
import colors from "@learningblocks/protocol-constants/lib/Styles/_exports.module.scss";


const toasterNotify = (type, msg, title) => {
    let color = "";
    if (type === "HINT") {
      color = colors.yellow1;
    } else {
      color = colors.red1;
    }

    toast(<Toast type={type} msg={msg} title={title} />, {
      className: css({
        border: "2px solid " + color,
        borderRadius: "6px",
        marginLeft: "-200px",
        minWidth: "400px"
      }),
      progressClassName: css({
        background: color
      }),
      position: "top-center",
      autoClose: 5000
    });
};

export const NOTIFY_EVENTS = {
  NOT_RUNNABLE: {
    title: "Microcentrifuge open or not balanced!",
    message: "Ensure that the tubes are balanced and the lid of centrifuge is closed."
  },
  BALANCED: {
    title: "Balanced!",
    message: "Looks balanced."
  },
  NOT_BALANCED: {
    title: "Not balanced!",
    message: "Distribute the tubes evently to balance the centrifuge."
  },
  // WRONG_NUMBER_TUBES: {
  //   title: "Wrong number of tubes!",
  //   message: "Wrong number of tubes."
  // },
  // WRONG_NUMBER_ROTORS: {
  //   title: "Wrong number of tubes!",
  //   message: "Wrong number of rotors."
  // },
  NOT_ALLOWED_CENTRIFUGE_RUNNING: {
    title: "Centrifuge running!",
    message: "Operation not avaliable while centrifuge running."
  },
};

export class Graphics extends Component {
  // standardBalance = (count, slots, type, callBack) => {
  //   let calcSpace = (12 - count) / count;
  //   let tubeFound = false;
  //   let firstSpace = 0;
  //   let lastSpace = 0;
  //   let spaceCount = 0;
  //
  //   slots.forEach((slot, index) => {
  //     if (type === "tube" ? slot.solutionId === null : slot.rotorId === null) {
  //       spaceCount++;
  //     } else if (index < slots.length - 1) {
  //       if (!tubeFound) {
  //         firstSpace = spaceCount;
  //         tubeFound = true;
  //       } else {
  //         if (spaceCount !== calcSpace) {
  //           //Wrong spacing - alert
  //           console.log("Please rebalance the centrifuge");
  //           toasterNotify("WARNING", NOTIFY_EVENTS.NOT_BALANCED.message, NOTIFY_EVENTS.NOT_BALANCED.title);
  //           callBack({
  //             id: this.props.id,
  //             balanced: false,
  //           });
  //           return false;
  //         }
  //       }
  //       spaceCount = 0;
  //     }
  //
  //     if (index === slots.length - 1) {
  //       if (
  //         type === "tube" ? slot.solutionId === null : slot.rotorId === null
  //       ) {
  //         lastSpace = spaceCount;
  //       } else {
  //         lastSpace = 0;
  //       }
  //     }
  //   });
  //
  //   //Check first and last space
  //   if (firstSpace + lastSpace !== calcSpace) {
  //     //Wrong spacing - alert
  //     toasterNotify("WARNING", NOTIFY_EVENTS.NOT_BALANCED.message, NOTIFY_EVENTS.NOT_BALANCED.title);
  //     callBack({
  //       id: this.props.id,
  //       balanced: false,
  //     });
  //     return false;
  //   }
  //
  //   return true;
  // };
  // cumulativeBalance = (count, slots, type, callBack) => {
  //   let calcSpace = (12 - count) / count;
  //   let tubeFound = false;
  //   let firstSpace = 0;
  //   let lastSpace = 0;
  //   let spaceCount = 0;
  //
  //   let firstTubes = 0;
  //   let lastTubes = 0;
  //   let consecTubes = 0;
  //   let calcTubes = 0;
  //   let spaceFound = false;
  //
  //   calcTubes = 1 / calcSpace;
  //
  //   slots.forEach((slot, index) => {
  //     if (type === "tube" ? slot.solutionId !== null : slot.rotorId !== null) {
  //       //no tube
  //       consecTubes++;
  //     } else if (index < slots.length - 1) {
  //       if (!spaceFound) {
  //         firstTubes = consecTubes;
  //         spaceFound = true;
  //       } else {
  //         if (consecTubes !== calcTubes) {
  //           //Wrong spacing - alert
  //           console.log("Please rebalance the centrifuge");
  //           toasterNotify("WARNING", NOTIFY_EVENTS.NOT_BALANCED.message, NOTIFY_EVENTS.NOT_BALANCED.title);
  //           this.props.checkMicrocentrifugeBalance({
  //             id: this.props.id,
  //             balanced: false,
  //           });
  //           return false;
  //         }
  //       }
  //       consecTubes = 0;
  //     }
  //
  //     if (index === slots.length - 1) {
  //       if (
  //         type === "tube" ? slot.solutionId === null : slot.rotorId === null
  //       ) {
  //         lastTubes = 0;
  //       } else {
  //         lastTubes = consecTubes;
  //       }
  //     }
  //   });
  //
  //   if (firstTubes + lastTubes !== calcTubes) {
  //     //Wrong spacing - alert
  //     console.log(
  //       "Please rebalance the centrifuge - first space error - cumulative"
  //     );
  //     toasterNotify("WARNING", NOTIFY_EVENTS.NOT_BALANCED.message, NOTIFY_EVENTS.NOT_BALANCED.title);
  //     this.props.checkMicrocentrifugeBalance({
  //       id: this.props.id,
  //       balanced: false,
  //     });
  //     return false;
  //   }
  //
  //   return true;
  // };
  checkBalance = () => {
    let tubesBalanced = this.centrifugeBalanced(this.props.slots);
    let rotorsBalanced = true;

    if (rotorsBalanced && tubesBalanced) {
      this.props.checkMicrocentrifugeBalance({
        id: this.props.id,
        balanced: true,
      });
      // toasterNotify("HINT", NOTIFY_EVENTS.BALANCED.message, NOTIFY_EVENTS.BALANCED.title);
      return true;
    }
  };

  centrifugeBalanced = (slots) => {

    let numberOfSlots = slots.length;
    let internalAngle = (360 / numberOfSlots); // Internal angle of a single slot

    let radius = 1; // Length from center (0,0) to a single slot (1,0)
    let balanceX = 0;
    let balanceY = 0

    slots.forEach((slot, i)=>{
      if(slot.solution){

        // Calculate the coordinate value for this slot (Math.sin / Math.cos require radians and not degrees)
        let oppositeSide = Math.sin((internalAngle * (i + 1)) * (Math.PI/180)) * radius;
        let adjacentSide = Math.cos((internalAngle * (i + 1)) * (Math.PI/180)) * radius;

        // Round the values to avoid floating point errors
        balanceX += +oppositeSide.toFixed(3);
        balanceY += +adjacentSide.toFixed(3);
      }
    })

    return (
      +balanceX.toFixed(3) === 0 &&
      +balanceY.toFixed(3) === 0
    );

  };

  render() {
    return (
      <Microcentrifuge
        id={this.props.id}
        isOpen={this.props.isOpen}
        slots={this.props.slots}
        balanced={this.props.balanced}
        centrifugeRunnable={this.props.centrifugeRunnable}
        showTooltipControls={this.props.showTooltipControls}
        showBalanceTubeModal={this.props.showBalanceTubeModal}
        showControlsModal={this.props.showControlsModal}
        rpmValue={this.props.rpmValue}
        timeValue={this.props.timeValue}
        timeLeft={this.props.timeLeft}
        alert={(event) => toasterNotify("WARNING", NOTIFY_EVENTS[event].message, NOTIFY_EVENTS[event].title)}
        toggleLid={(props) =>
          this.props.toggleMicrocentrifugeLid({
            id: this.props.id,
            isOpen: props,
          })
        }
        toggleShowTooltipControls={(props) =>
          this.props.toggleMicrocentrifugeTooltipsControls({
            id: this.props.id,
            showTooltipControls: props,
          })
        }
        toggleShowBalanceTubeModal={(props) =>
          this.props.toggleMicrocentrifugeBalanceTubeModal({
            id: this.props.id,
            showBalanceTubeModal: props,
          })
        }
        toggleShowControlsModal={(props) =>
          {
          this.props.toggleMicrocentrifugeControlsModal({
            id: this.props.id,
            showControlsModal: props,
          })
          this.props.setMicrocentrifugeTime({
            id: this.props.id,
            timeValue: new Date(2000, 1, 1, 0, 1, 0),
          })
        }
          
        }
        setRPM={(props) =>
          this.props.setMicrocentrifugeRPM({
            id: this.props.id,
            rpmValue: props,
          })
        }
        setTimeValue={(props) =>
          this.props.setMicrocentrifugeTime({
            id: this.props.id,
            timeValue: props,
          })
        }
        onTubeDrop={(props) =>
          this.props.onMicrocentrifugeTubeDrop({
            id: this.props.id,
            ...props,
          })
        }
        onInsertItem={(props) =>
          this.props.onMicrocentrifugeInsertItem({
            id: this.props.id,
            ...props,
          })
        }
        runCentrifuge={(props) =>
          this.props.onMicrocentrifugeRun({
            id: this.props.id,
          })
        }
        onEjectTube={() => {
          this.props.slots.forEach((slot) => {
            if (slot.solution) {
              this.props.setSolutionInScene({
                id: slot.solutionId,
                inScene: true,
              });
              if (slot.defaultProps && slot.defaultProps.originTubePosition && slot.defaultProps.originTubePosition.onIce) {
                this.props.setSolutionOnIce({
                  id: slot.solutionId,
                  onIce: slot.defaultProps.originTubePosition.onIce,
                });

                this.props.setSolutionInScene({
                  id: slot.solutionId,
                  inScene: false,
                });

                this.props.addTubeToIceBucket({
                  id: slot.defaultProps.originTubePosition.onIce,
                  solutionId: slot.solutionId,
                  type: slot.defaultProps.type,
                });

                this.props.setSolutionOnRack({
                  id: slot.solutionId,
                  onRack: false,
                })
              }
            }

          });

          this.props.ejectMicrocentrifugeTubes({
            id: this.props.id,
          });
        }}
        onEjectRotor={() => {
          this.props.slots.forEach((slot)=>{
            if(slot.rotor){
              this.props.setRotorAdaptersInScene({
                id: slot.rotorId,
                inScene: true,
              });
            }
          })
          this.props.ejectMicrocentrifugeRotors({
            id: this.props.id,
          });
        }}
        checkBalance={() => this.checkBalance()}
      />
    );
  }
}
